import { IElement, OneOfElements } from '@shared/models/project.model';
import { selectElementQuantity } from '../../element-quantity.helpers';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type QuantitySelectChange =
  ProjectChangeMap[ProjectChangeType.ElementQuantitySelect];

/**
 * Apply {@link selectElementQuantity} for the current element.
 */
export const elementQuantitySelectToChange = (
  element: OneOfElements,
  change: QuantitySelectChange,
): Partial<IElement> | undefined => {
  if (!projectGuards.is.element(element)) return undefined;

  const next = selectElementQuantity(element, change.quantityName);
  if (next.selectedQuantity === element.selectedQuantity) return undefined;

  return { selectedQuantity: next.selectedQuantity };
};
